module.exports = __webpack_public_path__ + "img/cis_2.5ac61b39.jpg";